<template>
    <v-app>
        <v-container>
            <v-row>
                <v-col>
                    <mass-dismiss-card
                        title="Mass dismiss submissions"
                        subtitle="Dismiss all submissions before a certain date"
                        route="/api/tools/massdeletesubmissions"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <mass-dismiss-card
                        title="Mass dismiss posting queue"
                        subtitle="Dismiss all posts in the posting queue accepted before a certain date"
                        route="/api/tools/massdeleteposts"
                    />
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import MassDismissCard from './MassDismissCard';

export default {
    name: "AdminTools",

    components: {
        MassDismissCard,
    },
}
</script>